import { render, staticRenderFns } from "./PolizaContable.vue?vue&type=template&id=d885f8ba"
import script from "./PolizaContable.vue?vue&type=script&lang=js"
export * from "./PolizaContable.vue?vue&type=script&lang=js"
import style0 from "./PolizaContable.vue?vue&type=style&index=0&id=d885f8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports